module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/axios/index.js
// module id = 323
// module chunks = 0